const HOW_NPS_works = [
  "Journey with NPS",
  "1. Start at 18 yrs: Begin contributing now and continue every year until you reach the age of 60.",
  "2. Till 60: It's time to retire. Withdraw up to 60% of your savings tax-free and invest the remainder for recurring income.",
  "3. Rest: For a stress-free retirement, take advantage of a monthly pension.",
];
const Invest_NPS = [
  "1:Tax Saving  When you invest ₹2 lakh, you can save up to ₹62,400 in taxes each year and receive a tax-free amount at maturity when you reach the age of 60.",
  "2:Cost-Effective  A low-cost investment with a larger return. Although the initial investment may be little, the greater compounding aspect of these plans allows an individual to earn significant profits at retirement.",
  "3:Disciplined Investment |Flip for content: Until you reach the age of 60, your investment is locked in. A minimum annual investment of Rs.1,000 is mandatory.",
  "4:Returns are guaranteed  These programmes provide better yields than other investments such as PPFs and FDs. The percentage of NPS invested in equities, on the other hand, may not provide guaranteed returns.",
  "5: Lifetime source of income  Inflation is having a negative influence on every part of our life. So, in order to continue your previous lifestyle, you'll need a steady source of money. NPS provides that choice in the form of a pension throughout the duration of your retirement, making it a lifesaver at a time when you most need financial assistance.",
  "6: Professionally managed  Your funds are invested and managed by the top pension fund managers in India.",
];
const eNPS_Facilities = [
  "1. Registration: To start an individual pension account with the NPS, you must first register. An Indian citizen between the ages of 18 and 70 can open a 'Tier I' or 'Tier I and Tier II both' account using this option, however an NRI/OCI can only register a 'Tier I' account. Using this option, you must OTP Authenticate eSign your Subscriber Registration form.",
  "2. Contribution: To make a Subsequent Contribution to your Tier I or Tier II account under NPS, click Contribution. This option is also available to Swavalamban account users who want to make a Subsequent Contribution. CRA fees will apply to such transactions and will be deducted from the Subscriber's NPS account separately as units. T+2 working days will be used for the investment (subject to receipt of clear funds from PGSP)",
  "3. Tier II Activation:  is used to activate a Tier II account under the NPS. This option is available to all existing Tier I subscribers who have an active Tier II account. There are no fees associated with the activation of a Tier II account.",
  "4. Get Same Day NAV (D-Remit): is a service that allows you to register for a Virtual Account number and make smooth investments straight from your bank account. The Direct Remittance (D-Remit) technique can be used to invest in NPS on the same day (T+0) (as per pre-defined cut-off time for receipt of funds at Trustee Bank).",
  "5. Annual Transaction Statement on email: For obtaining your Annual Transaction Statement for NPS transactions on your registered email ID, choose Annual Transaction Statement on Email.",
];
const nps_knowledge_content = [
  {
    header: "What is NPS?",
    body: "The National Pension Scheme (NPS) is a pension and investment system developed by the Indian government to give long-term financial security to Indian residents. It provides an attractive long-term saving alternative with a secure and regulated market-based return for correctly planning your retirement. The Pension Fund Regulatory and Development Authority (PFRDA) regulates it, and it provides a secure but transparent platform. When people reach retirement age, they get a lump sum payout as well as regular income, allowing them to live a stress-free retirement.",
  },
  {
    header: "Why should one invest in NPS?",
    body: Invest_NPS.join("\n"),
  },
  {
    header: "The Advantages of Investing in NPS",
    body: "An investor has access to the following benefits by investing in the National Pension Scheme.It is a voluntary initiative that is accessible to all Indian nationals between the ages of 18 and 60.The plan offers a lot of flexibility, allowing you to pick and select your investing possibilities.You may also choose from a variety of investment funds.The National Pension System (NPS) account may be accessed from anywhere in India.Transparent investment guidelines are part of the plan.It assists you in planning your retirement and ensures that you will receive guaranteed profits when you retire.Under section 80C of the Indian Income Tax Act, the subscriber can claim tax advantages on the payment paid to this plan.",
  },
  {
    header: "How NPS works",
    body: HOW_NPS_works.join("\n"),
  },
  {
    header: "In what areas are money invsted within NPS",
    body: "Depending on your investing strategy and age, your money is invested in a variety of asset classes(Equity, Government bonds, Corporate debts, Risk",
  },
  {
    header: "eNPS Facilities",
    body: eNPS_Facilities.join("\n"),
  },
];
const National_Pension_scheme = [
  "Online investing is available through the National Pension Scheme. Pension Fund Regulatory and Development Authority is in charge of it (PFRDA). This retirement benefit programme is funded by both employees and employers.",
  "The National Pension System (NPS) was created to encourage systematic savings among federal and state employees, as well as ordinary individuals. It is the lowest market-linked retirement plan accessible in India, and it was established on January 1, 2004 with the goal of reforming pension in India.",
];
const Min_and_max = [
  "The National Pension Scheme accepts the following contributions:",
  "A subscriber must pay a minimum annual donation of Rs. 6000. A one-time contribution of Rs. 500 is required. Tier-I accounts are eligible for these contributions.",
  "Similarly, Tier-II accounts require a minimum annual commitment of Rs. 2,000 and a one-time deposit of Rs. 250.",
];
const Tier = [
  "There are two types of NPS accounts: Tier I and Tier II.",
  "Tier I accounts are required for NPS investments, and all tax-saving benefits apply to this account category. It is, however, a limited and conditional withdrawable retirement account that may only be withdrawn if the NPS departure requirements are met.",
  "Tier-II accounts are optional and are accessible to any Tier-1 account user as an add-on. Subscribers can take their money out of this account whenever they like, but there are no tax advantages to investing in a Tier II account.",
];
const NPS_Calculator = [
  "Some investors get confused between Tier 1 and Tier 2 NPS accounts. Let’s make it simpler and understand how they differ and who can actually opt for these accounts.",
  "A tier 1 Account is a pure retirement account or as many call it, a pension plan account. A person who wants a monthly pension after Retirement has to open and invest in a Tier 1 account first. One can contribute to the account monthly or annually, with any amount they are comfortable investing. If you are confused as to how money can be invested in this account, visit the official site of NPS:  www.npstrust.org.in and check their online services for any query. There is also an application that can be downloaded on android or IOS mobile: National Pension System Trust, where all transactions can be made.",
  "The only bar to entry is the age limit- A person who between the 18 and 59 years of age can invest in NPS. They may be Central or State Government Employees, Corporate Employees, Self Employed or a Business Person.",
  "The major benefits of a Tier 1 account include higher long-term returns (as it has an equity component associated to it) and Tax benefits. The investment is mainly done in 3 sectors:",
  "1.  Equity: High Risk- High Returns and expected returns: 14-15%, this is usually looked upon for a long term.",
  "2. Corporate bonds: Moderate Risk- Moderate Returns and the expected returns: 9-10%",
  "3. Government Securities: Lower Risk- Steady Returns and the expected returns: 7-8%",
  "In Tier 1 accounts, the asset allocation is an active choice. The subscriber decides what percentage is to be invested in which sector. However, an important point to note is that they can’t invest 100% into equity. The maximum limit to the portion one can invest in equity is 75% and the remaining 25% should be invested in corporate bonds and government securities. Depending upon a subscriber’s risk capability, they can differ in the amount they wish to allocate to each sector of investment. The system of NPS also gives us an auto choice where the system suggests the amount that an individual can invest in Equity, Corporate bonds and Government Securities. The preference can be changed whenever the subscriber wishes to do it. A pension fund manager (PFM) can be changed once in a Financial Year, whereas the Asset allocation can be changed twice in a particular Financial Year.",
  "At the time of retirement, one can either get the amount to be invested for another 10 years till the age of 70 and then a Lump sum can be withdrawn along with the extra investment that was generated in 10 extra years. Another option is to exit from NPS, where one decides the Lump sum amount (maximum lump sum allowed is 60%) and what amount should be received in pension (minimum pension allowed is 40%) every month. Another myth customers have w.r.t. NPS is that their investment will not be returned in case of an untimely demise. The truth, however, is that your investment, along with any returns, are transferred to your nominee/spouse.",
  "A Tier 2 account is not compulsory if you are opting for NPS. However, if one wishes to have a Tier 2 account, the pre-requisite is that they have a Tier 1 account first. There is no minimum investment amount and there are no restrictions when it comes to withdrawal. It works just like Mutual Funds. The asset allocation within Equity, Corporate Bonds and, Government Securities can be done actively however, there are no tax benefits with this account. The benefit of Tier 2 account is that it saves you from building multiple folios, and gives you exposure and diversity when it comes to asset allocation.",
];

const Tax_benefits = [
  "A user can invest up to ₹2,000 in order to save 62,400 in taxes.",
  "To be qualified for a tax deduction under section 80CCD, you must invest up to ₹50,000. (1B) - A savings of ₹15,600 in taxes",
  "To be qualified for a tax deduction under section 80CCD, you must invest up to ₹150,000. (1) - ₹46,800 in tax savings",
  "Savings of 46,800 under section 80CCD (1) are an alternative to saving 46,800 on ₹150,000 under section 80C.",
];
const nps_faqs_content = [
  {
    header: "How to Make an Online Investment in the National Pension Scheme?",
    body: National_Pension_scheme.join("\n"),
  },
  {
    header: "Who can invest in a National Pension System (NPS)?",
    body: "The National Pension Scheme is open to residents and state/central government employees aged 18 to 60. Existing pension account holders must re-register under the new programme.",
  },
  {
    header: "How much do I contribute as a minimum and maximum?",
    body: Min_and_max.join("\n"),
  },
  {
    header: "What are the Tax benefits under NPS?",
    body: Tax_benefits.join("\n"),
  },
  {
    header: "In NPS, what are Tier I and II accounts?",
    body: Tier.join("\n"),
  },
  {
    header: "Does the government contribute to my NPS?",
    body: "The National Pension Scheme (NPS) is a Government of India attempt to give citizens of India with long-term financial stability. However, the Government will not contribute to your NPS account. Individuals, under the all citizens of India concept, or employee-employer groups, under the corporate model, are the only ones who contribute to the NPS account.",
  },
  {
    header:
      "NPS Calculator for Retirement Planning - Tier 1 vs Tier 2 Accounts",
    body: NPS_Calculator.join("\n"),
  },
];
const family_description_code = [
  {
    family_description: "Self",
    family_code: "SE",
  },
  {
    family_description: "Spouse",
    family_code: "SP",
  },
  {
    family_description: "Dependent Children",
    family_code: "DC",
  },
  {
    family_description: "Dependent Siblings",
    family_code: "DS",
  },
  {
    family_description: "Dependent Parents",
    family_code: "DP",
  },
  {
    family_description: "Guardian",
    family_code: "GD",
  },
];
const ktrack_go = [
  {
    nm_description: "Change of email Address",
    Number: "KMF008",
  },
  {
    nm_description: "chnage in phone  number",
    fnm_code: "KMF072",
  },
  {
    nm_description: "Both",
    nm_code: "KMF072",
  },
];
const active_columns = [
  { key: "Investor", name: "Investor" },
  { key: "Scheme", name: "Scheme" },
  { key: "FolioNumber", name: "Folio Number" },
  {
    key: "No of Installments",
    name: "No of Installments",
    subtitle: "(Total)",
  },
  { key: "Start Date 0f SIP", name: "Start Date 0f SIP" },
  { key: "End Date of SIP", name: "End Date of SIP" },
  { key: "Amount", name: "Amount" },
  {
    key: "Mode_of_Registration",
    name: `Mode of Registration`,
    subtitle: "(OTM/ISIP/Others)",
  },
  {
    key: "Biller_ID /OTM_(UMR)_Number",
    name: `Biller ID/ Number`,
    subtitle: "(URN)/OTM (UMR)",
  },
  // { key: 'SIP_Registration_Status', name: `SIP Registration`, subtitle: '(Authorized/Pending)' },
];
const pending_columns = [
  { key: "Investor", name: "Investor" },
  { key: "Scheme", name: "Scheme" },
  { key: "FolioNumber", name: "Folio Number" },
  { key: "Amount", name: "Amount" },
  {
    key: "Mode_of_Registration",
    name: `Mode of Registration`,
    subtitle: "(OTM/ISIP/Others)",
  },
  { key: "Rejection Reason", name: "Rejection Reason" },
  {
    key: "Biller_ID /OTM_(UMR)_Number",
    name: `Biller ID/ Number`,
    subtitle: "(URN)/OTM (UMR)",
  },
  // { key: 'SIP_Registration_Status', name: `SIP Registration`, subtitle: '(Authorized/Pending)' },
  { key: "Status", name: "Status" },
];
const fmp_columns = [
  { key: "Investor", name: "Investor" },
  { key: "Scheme", name: "Scheme" },
  { key: "FolioNumber", name: "Folio Number" },
  { key: "Maturity Date", name: "Maturity Date" },
  { key: "Amount", name: "Amount" },
];

export {
  nps_faqs_content,
  nps_knowledge_content,
  family_description_code,
  ktrack_go,
  active_columns,
  pending_columns,
  fmp_columns,
};
